import React, { Suspense } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { FormProvider } from '../contexts/FormContext';
import Loader from '../components/Loader';

const FormViewer = React.lazy(() => import('../components/FormViewer'));

const FormPage: React.FC = () => {
    const { formId } = useParams();
    const [searchParams] = useSearchParams();
    const preview = searchParams.get('preview') === 'true';

    if (!formId) {
        return <div>ID do formulário não informado na URL.</div>;
    }

    return (
        <Container>
            <FormProvider>
                <Suspense fallback={<Loader />}>
                    <FormViewer formId={formId} preview={preview} />
                </Suspense>
            </FormProvider>
        </Container>
    );
};

export default FormPage;
